import { render, staticRenderFns } from "./KPI.vue?vue&type=template&id=fc7496b4&scoped=true"
import script from "./KPI.vue?vue&type=script&lang=js"
export * from "./KPI.vue?vue&type=script&lang=js"
import style0 from "./KPI.vue?vue&type=style&index=0&id=fc7496b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7496b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc7496b4')) {
      api.createRecord('fc7496b4', component.options)
    } else {
      api.reload('fc7496b4', component.options)
    }
    module.hot.accept("./KPI.vue?vue&type=template&id=fc7496b4&scoped=true", function () {
      api.rerender('fc7496b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/vueComponents/dashboardContainer/src/panels/KPI.vue"
export default component.exports